import { render, staticRenderFns } from "./BookingLogsModel.vue?vue&type=template&id=edc44132"
import script from "./BookingLogsModel.vue?vue&type=script&lang=js"
export * from "./BookingLogsModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports